import type { ReactorData } from "shared/schema";
import type { Item, Query } from "shelving";
import { Ago, Table } from "shared/react";
import { ProfileButton } from "../entity/EntityButton.js";
import { RewardIcon } from "../reward/RewardIcon.js";
import { useQuery } from "../util/db.js";

export function ReactorsTable({ query }: { query: Query<ReactorData> }): React.ReactElement {
	return (
		<Table //
			store={useQuery("reactor", query)}
			mapper={({ uid, reaction, date }: Item<ReactorData>) => (
				<tr key={uid}>
					<td className="width-fit">
						<RewardIcon id={reaction} mods="size-xlarge" type="reaction" />
					</td>
					<td>
						<ProfileButton uid={uid} />
					</td>
					<td>
						<Ago target={date} />
					</td>
				</tr>
			)}
		/>
	);
}
